import { Role } from './roles';

export enum EUserTokenNames {
  accessToken = 'accessToken',
  authToken = 'authToken',
  refreshToken = 'refreshToken',
}

export interface IUser {
  referenceId: string;
  companyId: string;
  email: string;
  fullName: string;
  createdAt: string;
}

export interface IInviteUser {
  email: string;
  customerId: string;
  fullName?: string;
  role: Role;
}
